import * as actions from "./actions";
import {
  chartConfig,
  getEmptyStatistics,
} from "../../states/statistics/Statistics.Helper";

let initialState = {
  //transactionsRangeData: { data: [], fetching: false, fetched: false },
  //statisticsRangeData: { data: [], fetching: false, fetched: false },
  fetching: false,
  fetched: false,
  rawData: {},
  calculated: false,
  chart: {},
  statistics: {},
};
import moment from "moment";

function getLastWeek(date) {
  return moment(new Date(date)).subtract(7, "days").hour(0).minute(0);
}

function getToday(date) {
  return moment(new Date(date)).hour(23).minute(59);
}

const statistics = (state = initialState, action) => {
  switch (action.type) {
    case actions.STATISTICS_RANGE_COMBINED_REQUEST:
      return Object.assign({}, state, {
        fetching: true,
        fetched: false,
      });

    case action.STATISTICS_RANGE_COMBINED_SUCCESS:
      return Object.assign({}, state, {
        fetching: false,
        fetched: true,
      });

    case actions.STATISTICS_CALCULATED:
      return Object.assign({}, state, {
        calculated: true,
        chart: action.response.chart,
        statistics: action.response.statistics,
      });

    case actions.STATISTICS_RANGE_COMBINED_ERROR:
      return Object.assign({}, state, {
        calculated: true,
        fetching: false,
        fetched: true,
        chart: chartConfig(
          {
            Deposit: true,
            Investment: true,
            Interest: true,
          },
          "day",
          [],
          new Date(getLastWeek(new Date())),
          new Date(getToday(new Date())),
        ),
        statistics: getEmptyStatistics(),
      });
    default:
      return state;
  }
};

export default statistics;
